import React from "react";
import "./styles.css";
import apiData from "../../../data/epicTravelData.json";

const HotelLanding = () => {
  const data = apiData.data;

  const handleButtonClick = () => {
    console.log("Button clicked");
  };

  const logoUrl = data?.attributes?.EpicTravelLogo?.data?.attributes?.url || '';
  const groupImgUrl = data?.attributes?.GroupImgHeader?.data?.[0]?.attributes?.url || '';
  const layer1Img = data?.attributes?.ImageLayer1?.data?.attributes?.url || '';
  const layer2Img = data?.attributes?.ImageLayer2?.data?.attributes?.url || '';
  const layer3Img = data?.attributes?.ImageLayer3?.data?.attributes?.url || '';
  const layer4Img = data?.attributes?.ImageLayer4?.data?.attributes?.url || '';
  const mindmapImg = data?.attributes?.MindmapImage?.data?.attributes?.url || '';

  return (
    <div className="hotel-landing">
      {/* Page 1 - Hero Section */}
      <section className="hotel-page-section hotel-page-1">
        <div className="hotel-page-1-container">
          {/* Logo */}
          <div className="hotel-logo-section">
            {logoUrl && <img src={logoUrl} alt="EpicTravel" className="hotel-epictravel-logo" />}
          </div>

          {/* Main Content */}
          <div className="hotel-main-content">
            <h1 className="hotel-hero-title">
              {data?.attributes?.MainHeader || "2 out of 5 travelers now plan trips with AI."}
            </h1>
            
            <h2 className="hotel-hero-subtitle">
              {data?.attributes?.SubHeader || "If AI aren't recommending your hotel, you're losing bookings."}
            </h2>

            <p className="hotel-hero-description">
              {data?.attributes?.SubTitle || "We optimize your hotel to rank as the #1 choice, so travelers can easily book your hotel within the AI instead of the competitor next door."}
            </p>

            <button className="hotel-hero-cta-button" onClick={handleButtonClick}>
              {data?.attributes?.ButtonSeeAI || "See what AI says about your hotel"}
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>

          {/* Phone with Hotels Image */}
          <div className="hotel-phone-hotels-section">
            {groupImgUrl && (
              <img src={groupImgUrl} alt="ChatGPT Hotel Recommendations" className="hotel-phone-hotels-image" />
            )}
          </div>
        </div>
      </section>

      {/* Page 2 - Four Capabilities */}
      <section className="hotel-page-section hotel-page-2">
        <div className="hotel-page-2-container">
          <h2 className="hotel-page-2-title">
            {data?.attributes?.SecondHeaderPoint || "The four capabilities that turns AI conversations into direct bookings"}
          </h2>
          <p className="hotel-page-2-subtitle">
            {data?.attributes?.SecondHeaderPointSub || "We deliver our solution through four connected service layers — each building on the previous to activate your business for AI."}
          </p>

          <div className="hotel-layers-wrapper">
            {/* Layer 1 */}
            <div className="hotel-layer-card">
              {layer1Img && (
                <div className="hotel-layer-image-wrapper">
                  <img src={layer1Img} alt="Layer 1" className="hotel-layer-img" />
                </div>
              )}
              <div className="hotel-layer-content">
                <span className="hotel-layer-number">{data?.attributes?.Layer1 || "Layer 1"}</span>
                <h3 className="hotel-layer-title">{data?.attributes?.Layer1Title || "Make Your Hotel AI-Understandable"}</h3>
                <p className="hotel-layer-text">
                  {data?.attributes?.Layer1Content || "Your website is written for humans, so it contains only brief marketing information. AI models, however, need hundreds of structured data points to understand, compare, and recommend your hotel."}
                </p>
              </div>
            </div>

            {/* Layer 2 */}
            <div className="hotel-layer-card">
              {layer2Img && (
                <div className="hotel-layer-image-wrapper">
                  <img src={layer2Img} alt="Layer 2" className="hotel-layer-img" />
                </div>
              )}
              <div className="hotel-layer-content">
                <span className="hotel-layer-number">{data?.attributes?.Layer2 || "Layer 2"}</span>
                <h3 className="hotel-layer-title">{data?.attributes?.Layer2Title || "Make Your Hotel AI-Trusted"}</h3>
                <p className="hotel-layer-text">
                  {data?.attributes?.Layer2Content || "AI doesn't recommend businesses it can't trust. We verify your identity, optimise your hotel information, and keep your data fresh."}
                </p>
              </div>
            </div>

            {/* Layer 3 */}
            <div className="hotel-layer-card">
              {layer3Img && (
                <div className="hotel-layer-image-wrapper">
                  <img src={layer3Img} alt="Layer 3" className="hotel-layer-img" />
                </div>
              )}
              <div className="hotel-layer-content">
                <span className="hotel-layer-number">{data?.attributes?.Layer3 || "Layer 3"}</span>
                <h3 className="hotel-layer-title">{data?.attributes?.Layer3Title || "Make Your Hotel AI-Bookable"}</h3>
                <p className="hotel-layer-text">
                  {data?.attributes?.Layer3Content || "To convert AI recommendations into real bookings, your hotel must be bookable inside the conversation. We connect your live inventory, rates, and availability."}
                </p>
              </div>
            </div>

            {/* Layer 4 */}
            <div className="hotel-layer-card">
              {layer4Img && (
                <div className="hotel-layer-image-wrapper">
                  <img src={layer4Img} alt="Layer 4" className="hotel-layer-img" />
                </div>
              )}
              <div className="hotel-layer-content">
                <span className="hotel-layer-number">{data?.attributes?.Layer4 || "Layer 4"}</span>
                <h3 className="hotel-layer-title">{data?.attributes?.Layer4Title || "Keep Your Data Fresh"}</h3>
                <p className="hotel-layer-text">
                  {data?.attributes?.Layer4Content || "AI models rank hotels higher when they see fresh, verified, and local context. Our community continuously updates insights and content around your hotel."}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Page 3 - 4 Steps Timeline */}
      <section className="hotel-page-section hotel-page-3">
        <div className="hotel-page-3-container">
          <h2 className="hotel-page-3-title">
            {data?.attributes?.ThirdHeaderPoint || "Activate your business for AI in 4 simple steps"}
          </h2>

          <div className="hotel-timeline-wrapper">
            {/* Step 1 - Audit */}
            <div className="hotel-timeline-step">
              <div className="hotel-step-badge">{data?.attributes?.Audit || "Audit"}</div>
              <div className="hotel-step-content">
                <h3 className="hotel-step-heading">Understand how AI currently sees your business</h3>
                <p className="hotel-step-description">
                  We scan how your business appears across GPT, Gemini, OTAs, and major data sources to identify gaps, inconsistencies, and blockers that prevent AI from recommending you.
                </p>
                <p className="hotel-step-subheading">What you get:</p>
                <ul className="hotel-step-list">
                  <li>EARS™ AI visibility score</li>
                  <li>How GPT & Gemini currently describe your business</li>
                  <li>Missing or weak data preventing recommendations</li>
                  <li>Clear, prioritised improvement opportunities</li>
                  <li>Competitor comparison for context</li>
                </ul>
              </div>
            </div>

            {/* Step 2 - Verification */}
            <div className="hotel-timeline-step">
              <div className="hotel-step-badge">{data?.attributes?.Verification || "Verification"}</div>
              <div className="hotel-step-content">
                <h3 className="hotel-step-heading">Become a trusted source AI can rely on</h3>
                <p className="hotel-step-description">
                  AI only recommends businesses it considers accurate and reliable. We correct conflicts, verify key details, and officially validate your business so AI recognises it as a single source of truth.
                </p>
                <p className="hotel-step-subheading">What we verify:</p>
                <ul className="hotel-step-list">
                  <li>Property details, room types, facilities</li>
                  <li>Policies, photos, licenses</li>
                  <li>Business identity and ownership (AI trust signal)</li>
                </ul>
              </div>
            </div>

            {/* Step 3 - Connection */}
            <div className="hotel-timeline-step">
              <div className="hotel-step-badge">{data?.attributes?.Connection || "Connection"}</div>
              <div className="hotel-step-content">
                <h3 className="hotel-step-heading">Move from discoverable to bookable</h3>
                <p className="hotel-step-description">
                  We connect your live availability and rates directly into the AI layer, enabling AI agents to not just mention your business — but check availability and support bookings instantly.
                </p>
                <p className="hotel-step-subheading">What's activated:</p>
                <ul className="hotel-step-list">
                  <li>Real-time rates & availability</li>
                  <li>AI-friendly booking flows</li>
                  <li>Instant checkout within AI experiences</li>
                </ul>
              </div>
            </div>

            {/* Step 4 - Amplification */}
            <div className="hotel-timeline-step">
              <div className="hotel-step-badge">{data?.attributes?.Amplification || "Amplification"}</div>
              <div className="hotel-step-content">
                <h3 className="hotel-step-heading">Stay relevant as AI keeps learning</h3>
                <p className="hotel-step-description">
                  AI rankings favour businesses with fresh, real-world signals. We activate a network of verified travel creators and local experts to continuously refresh how AI understands and ranks your business.
                </p>
                <p className="hotel-step-subheading">How this helps:</p>
                <ul className="hotel-step-list">
                  <li>New, trusted signals feed AI regularly</li>
                  <li>Higher confidence and relevance over time</li>
                  <li>Sustained visibility without manual upkeep</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Page 4 - Infrastructure Ecosystem */}
      <section className="hotel-page-section hotel-page-4">
        <div className="hotel-page-4-container">
          <h2 className="hotel-page-4-title">
            {data?.attributes?.FourthHeaderPoint || "One infrastructure layer supporting every major tourism sector"}
          </h2>
          <p className="hotel-page-4-subtitle">
            {data?.attributes?.FourthHeaderPointSub || "A national-scale ecosystem that connects every part of tourism, giving AI more pathways to surface your business and increase your visibility."}
          </p>

          <div className="hotel-ecosystem-diagram">
            {mindmapImg && (
              <img src={mindmapImg} alt="Tourism Ecosystem" className="hotel-mindmap-image" />
            )}
          </div>

          <div className="hotel-cta-button-wrapper">
            <button className="hotel-assess-button" onClick={handleButtonClick}>
              {data?.attributes?.AccessAIButton || "Assess your AI visibility across the network"}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Page 5 - Final CTA / Footer */}
      <section className="hotel-page-section hotel-page-5">
        <div className="hotel-page-5-container">
          <h2 className="hotel-page-5-title">
            {data?.attributes?.FifthHeaderPoint || "The $12B AI wave is here. Are you riding it or watching it pass?"}
          </h2>
          <p className="hotel-page-5-subtitle">
            {data?.attributes?.FifthHeaderPointSub || "Businesses that connect to AI in 2025 will dominate the next decade."}
          </p>

          <div className="hotel-final-cta">
            <button className="hotel-final-cta-button" onClick={handleButtonClick}>
              {data?.attributes?.EARSDiagnosticFREE || "Get Your EARS™ Diagnostic Report for free, within 48 hours"}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HotelLanding;
